import { Form } from "react-router-dom";
import { arrow_right, searchIcon } from "../../assets/icons";
import styles from "./searchbar.module.css";
import { useRef, useState } from "react";

interface Props {
  children?: React.ReactNode;
  placeholder: string;
  hideArrow?: boolean;
  mobile?: boolean;
  header?: boolean;
}
export default function Searchbar({
  children,
  placeholder,
  hideArrow,
  mobile,
  header,
}: Props) {
  const [inputValue, setInputValue] = useState("");
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (formRef.current) {
      formRef.current.submit();
      setInputValue(""); // Reset the input field
    }
  };
  return (
    <div className={`${styles.search_container} ${mobile && styles.mobile} ${header && styles.header}`}>
      <i aria-hidden="true">{searchIcon}</i>
      <Form ref={formRef} action="/search" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder={placeholder}
          name="q"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        ></input>
        {!hideArrow && <button aria-label="search">{arrow_right}</button>}
        {children}
      </Form>
    </div>
  );
}
